import axios, { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";
import SegmentPreviewRequest from "../request/SegmentPreviewRequest";
import SegmentPreviewResponse from "../model/SegmentPreviewResponse";

export const SegmentPreviewApiService = async (
  request: SegmentPreviewRequest
): Promise<SegmentPreviewResponse> => {
  const {
    segmentId,
    rules,
    logic_operator: logicOperator,
    limit,
    count_all: countAll,
  } = request;

  if (segmentId) {
    // Existing segment: use detail endpoint
    const url = `/segments/${segmentId}/preview/`;
    const { data } = await axios.post(url, { limit, count_all: countAll });
    return data;
  }
  // New segment: use preview-rules endpoint with rules in body
  const url = "/segments/preview-rules/";
  const { data } = await axios.post(url, {
    rules,
    logic_operator: logicOperator,
    limit,
    count_all: countAll,
  });
  return data;
};

const useSegmentPreviewApiService = (
  request: SegmentPreviewRequest,
  enabled = true
): UseQueryResult<SegmentPreviewResponse, AxiosError> =>
  useQuery<SegmentPreviewResponse, AxiosError>(
    ["SegmentPreviewApiService", JSON.stringify(request)],
    () => SegmentPreviewApiService(request),
    {
      enabled,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 0, // Mark data as stale immediately for fresh fetches
    }
  );

export default useSegmentPreviewApiService;
